import { render, staticRenderFns } from "./AdminDeliveries.vue?vue&type=template&id=e33ebef0&scoped=true&"
import script from "./AdminDeliveries.vue?vue&type=script&lang=js&"
export * from "./AdminDeliveries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33ebef0",
  null
  
)

export default component.exports